import { useEffect, Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AnnouncementBar from "./AnnouncementBar";
import Nav from "./Nav";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import { LightboxProvider } from "./Lightbox";
import useScrollReveal from "../hooks/useScrollReveal";

export default function Layout() {
  // `key` changes on EVERY navigation — including clicking a nav link for the
  // page you are already on — so re-clicking "Brackets" at the bottom of the
  // brackets page still scrolls back to the top.
  const { hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      window.setTimeout(() => {
        const target = document.querySelector(hash);
        if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 0);
      return;
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [key, hash]);

  // Subtle section reveal-on-scroll; re-runs per navigation.
  useScrollReveal(key);

  return (
    <LightboxProvider>
      {/* The bar scrolls away; the nav below it is what sticks. No offset maths. */}
      <AnnouncementBar />
      <Nav />
      <main data-testid="page-main">
        {/* Lazy-loaded routes suspend here — Nav/Footer stay mounted so only the
            page body swaps. min-height holds the footer down to avoid a jump. */}
        <Suspense fallback={<div style={{ minHeight: "70vh" }} />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <CartDrawer />
    </LightboxProvider>
  );
}
